var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-tables',{staticClass:"first-checkbox",attrs:{"tableClass":_vm.tableClass,"columns":_vm.getColumns,"rows":_vm.processedDownTimes,"drawTrigger":_vm.drawTick,"tableID":"job-downtimes-dt","routerLinkClass":"dt-router-link","tableInitOptions":_vm.tableInitOptions,"customFilters":_vm.customFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }